import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, tap} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {AuthService} from './auth.service';
import {AccountInfo} from '../entities';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private readonly baseUrl = environment.apiUrl;
  private readonly account$ = new BehaviorSubject<AccountInfo | null>(null);

  readonly account = this.account$.asObservable();

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
  }

  private getHeaders(): HttpHeaders {
    return new HttpHeaders().set('x-api-key', this.authService.getApiKey());
  }

  /**
   * Hit /account to fetch identity info. If `overrideKey` is provided, the
   * request uses that key directly (rather than the one stored in AuthService)
   * — useful for validating a candidate key before saving it.
   * On 200 the result is pushed into account$.
   */
  fetchAccount(overrideKey?: string): Observable<AccountInfo> {
    const url = this.baseUrl + '/account';
    const key = overrideKey ?? this.authService.getApiKey();
    const headers = new HttpHeaders().set('x-api-key', key);
    return this.http.get<AccountInfo>(url, {headers}).pipe(
      tap(info => this.account$.next(info))
    );
  }

  clear(): void {
    this.account$.next(null);
  }

  get snapshot(): AccountInfo | null {
    return this.account$.value;
  }
}
